/** Internal dependencies */
import { fadeOut } from '../utilities';
import { loadHbstmpl } from './loadHbstmpl';
import { loadAjax } from './loadAjax';

/**
 * Replace appropriate query information into the API url
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @export
 *
 * @param {string} url Original rest endpoint from `[data-ct-rest]` information
 * @param {object} api Original rest information
 *
 * @returns {string} The updated URL
 */
export function prepareUrl(url, api) {
    Object.keys(api).forEach((k) => {
        url = url.replace('#' + k + '#', api[k]);
    });

    return url;
}

/**
 * Delete/remove all children of the given container
 *
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {*} container
 */
export function deleteItems(container) {
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }
}

/**
 * Waits 100ms to make sure the item has been added and is loaded, then gets it adds a class and triggers a custom jQuery event
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {string} id
 */
export function showItem(id) {
    setTimeout(function () {
        const item = document.querySelector(`[data-ct-item="${id}"]`);
        if (item) {
            item.classList.add('shownow');

            // check for inner hbstmpl's
            const innerHbs = item.querySelectorAll('.hbstmpl');
            if (innerHbs) {
                innerHbs.forEach((element) => loadHbstmpl(element));
            }

            // check for inner rest elements
            const innerParents = item.querySelectorAll('[data-ct-rest]');
            if (innerParents) {
                innerParents.forEach((innerParent) => loadAjax(innerParent));
            }
        }
    }, 100);
}

/**
 * Hide the loadmore button if it exists
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {HTMLElement} parent
 */
export function finish(parent) {
    const btnLoadMore = parent.querySelector('[data-ct-loadmore]');

    if (btnLoadMore) {
        fadeOut(btnLoadMore);
    }
}

/**
 * Format the array of query strings to your use case.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {array} activeFilters An array of query strings per active filter
 * @returns {string} prepared valid query string for use as GET params in fetch call
 */
export function prepareApiFilterString(activeFilters) {
    return activeFilters.join('&').replaceAll('%2C', encodeURIComponent('|'));
}
